import { render, staticRenderFns } from "./addGoods_ec.vue?vue&type=template&id=77ad27eb&scoped=true&"
import script from "./addGoods_ec.vue?vue&type=script&lang=js&"
export * from "./addGoods_ec.vue?vue&type=script&lang=js&"
import style0 from "./addGoods_ec.vue?vue&type=style&index=0&lang=less&"
import style1 from "./addGoods_ec.vue?vue&type=style&index=1&id=77ad27eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ad27eb",
  null
  
)

component.options.__file = "addGoods_ec.vue"
export default component.exports